export default {
  title: 'Beworbene Produkte',
};
